import React from "react";
import InteractiveMapPage from "../interactiveMapPage";

const events = [];

export default function Hungary() {
  return <InteractiveMapPage events={events} countryName="Hungary" />;
}
